import List from './List';

const Customers = () => {
  return <List />;
};

export default Customers;
